import { render, staticRenderFns } from "./Turnkey.vue?vue&type=template&id=da96d2ee&scoped=true&"
import script from "./Turnkey.vue?vue&type=script&lang=js&"
export * from "./Turnkey.vue?vue&type=script&lang=js&"
import style0 from "./Turnkey.vue?vue&type=style&index=0&id=da96d2ee&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da96d2ee",
  null
  
)

export default component.exports